export default class AchAccountBasicInfo {
  constructor(data = {}) {
    this.accountName = data.accountName;
    this.accountType = data.accountType;
    this.bankName = data.bankName;
    this.microDepositStatus = data.microDepositStatus;
  }
}
